var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    viewBox: "0 0 12 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 4V0h6l6 4v4H6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#da121a",
    d: "M6 0h6v4H6zm3 5 .65 2-1.702-1.236h2.103L8.352 7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#072357",
    d: "M0 4h6v4H0zm3-3 .65 2-1.702-1.236h2.104L2.35 3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPa);
export default __webpack_public_path__ + "static/media/pa.dd2a25b6e8813d6ab1f82aa0d2f47873.svg";
export { ForwardRef as ReactComponent };